/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionalsStatusesCountResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'all-of',
        contains: [{
          type: 'ProfessionalsStatusesCountData',
        }],
        isRequired: true,
      },
    },
  }],
} as const;
